module.exports = __webpack_public_path__ + "img/1.53c43902.jpg";